import { Text, Grid, GridWall, Icon, useIsBreakpointLargeAndUp, Theme, useIsTheme } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { Money as MoneyComponent } from '../'
import { useCheckoutSizes } from '../../utils/responsive'
import { useCheckoutColor } from '../../utils/color'
import { Money } from '@afterpay/types'

interface Props {
  name?: string
  description?: string | (() => any)
  shippingAmount?: Money
  showArrow?: boolean
  isCollapse?: boolean
  hasSelectedShippingOption?: boolean
  disabled?: boolean
}

export const ShippingOptionItem: FunctionComponent<Props> = ({
  name = '',
  description,
  shippingAmount,
  showArrow = false,
  isCollapse = false,
  hasSelectedShippingOption = false,
  disabled = false,
}) => {
  const { textSize, smallTextSize } = useCheckoutSizes()
  const isDesktop = useIsBreakpointLargeAndUp()
  const isAPTheme = useIsTheme(Theme.AP)
  const { subtextColor, headingTextColor, iconColor } = useCheckoutColor({ isDisabled: disabled })

  return (
    <Grid center={isAPTheme}>
      <GridWall columns={1} gutter='none'>
        <span className={styles.labelWrapper}>
          <Text size={textSize} renderAs='span' bold color={headingTextColor}>
            {name}
          </Text>
        </span>

        <Text size={smallTextSize} color={subtextColor}>
          {description as string}
        </Text>
      </GridWall>

      <Grid.FixedItem width={isAPTheme ? (isDesktop ? 80 : 70) : undefined} align='right'>
        <MoneyComponent value={shippingAmount} showFree size={textSize} bold={showArrow || !hasSelectedShippingOption} color={headingTextColor} />
      </Grid.FixedItem>
      {hasSelectedShippingOption && (
        <Grid.FixedItem width={5} align='right'>
          {showArrow && (isCollapse ? <Icon.CaretUp color={iconColor} size='ExtraSmall' /> : <Icon.CaretDown color={iconColor} size='ExtraSmall' />)}
        </Grid.FixedItem>
      )}
    </Grid>
  )
}
